
<ng-container *ngIf="loading else content">
	<div class="min-h-screen">
		<div class="vertically-centralized">
			<app-kamona-loading [parentHeight]="'10'"> </app-kamona-loading>
		</div>
	</div>
</ng-container>
<ng-template #content>
	<app-web-timeline-template-v2
		[formSubTitle]="subTitle"
		[formTitle]="title"
		[steps]="formSteps"
		[subTitle]="Dictionary.Upgrade_Business_Owners_Account_to_Level_2"
		[title]="Dictionary.Level_2_Upgrade"
		[showBackButton]="true"
		(goBack)="goBack()">
		<div>
			<ng-container *ngTemplateOutlet="formContent"></ng-container>
		</div>
	</app-web-timeline-template-v2>
</ng-template>

<ng-template #formContent>
	<ng-container [ngSwitch]="currentView">
		<ng-container *ngSwitchCase="KYC_IDENTITY_TYPE.BVN">
			<app-onboarding-bvn-verification-web
				[useSubmitOnly]="true"
				[useBvnDate]="false"
				(emitSubmit)="submitBvn($event, true)"
				[formData]="formData"
				[submitting]="submitting">
			</app-onboarding-bvn-verification-web>
		</ng-container>
		<ng-container *ngSwitchCase="KYC_IDENTITY_TYPE.NIN">
			<app-onboarding-bvn-verification-web
				[useSubmitOnly]="true"
				bvnLabel = 'NIN'
				[useCustomInfoCard]="true"
				[useBvnDate]="false"
				(emitSubmit)="submitNin($event, true)"
				[formData]="formData"
				[submitting]="submitting">
				<div>
					<div class="bg-[#E6EEFD] p-[12px] flex gap-[9px] rounded-[8px]">
						<div>
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9939 17.5203 17.5203 21.9939 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" fill="#0361F0"/>
							</svg>
						</div>
						<div class="text-[#1A0C2F] text-[12px] font-normal leading-[17.577px]">
							<div>Dial <span class="text-[#0361F0] font-bold">*346#</span> on your registered phone number to get your</div>
							<div>NIN. Service costs <span class="font-bold">₦20.00.</span> </div>
							<div><span class="text-[#0361F0] cursor-pointer font-bold" (click)="openNinPage()">Visit nimc.gov.ng/sms-service</span></div>
						</div>
					</div>
				</div>
			</app-onboarding-bvn-verification-web>
		</ng-container>
	</ng-container>
</ng-template>
